export const STRIPE_ERROR_CODE_MAP: Record<string, string> = {
  // Terminal errors
  no_established_connection:
    'No terminal reader is currently connected. Please make sure your reader is connected to the internet and try again.',
  no_active_collect_payment_method_attempt: 'There is currently no in-progress transaction to be canceled.',
  no_active_read_reusable_card_attempt: 'There is currently no in-progress transaction to be canceled.',
  canceled: 'The process was canceled.',
  cancelable_already_completed: 'Cancellation failed because the operation has already completed.',
  cancelable_already_canceled: 'Cancellation failed because the operation has already been canceled.',
  network_error: 'An unknown error occurred when communicating with the server or reader over the network.',
  network_timeout:
    'The request timed out when communicating with the server or reader over the network. Make sure both your device and the reader are connected to the network with stable connections.',
  already_connected: 'The terminal reader is already connected.',
  failed_fetch_connection_token:
    'The server was unable to retrieve a connection token for your device. Otto staff has been alerted and is looking to resolve the issue as soon as possible.',
  discovery_too_many_readers:
    'Too many readers are associated with this Stripe account. Please set up terminal locations to reduce the number of active readers.',
  invalid_reader_version:
    'The reader is running an unsupported software version. Please allow the reader to update by disconnecting and reconnecting the power source, and try again.',
  reader_error:
    'The reader returned an error while processing the request. Please make sure your reader is online and on the same network as your device.',
  command_already_in_progress: 'The action cannot be performed, because there is an in-progress action preventing it.',
  payment_intent_unexpected_state:
    'An unexpected error occurred. Otto staff has been alerted and is looking to resolve the issue as soon as possible.',
  call_issuer:
    'There was an issue processing this payment method. Please call the issuer of the payment method to resolve the issue.',
  offline_pin_required: 'Please enter the pin code into the terminal reader.',
  online_or_offline_pin_required: 'Please enter the pin code into the terminal reader.',
  generic_decline: 'The payment has been declined. Please try a different payment method.',
  withdrawal_count_limit_exceeded: 'The payment was declined because the withdrawal count limit has been exceeded.',
  pin_try_exceeded: 'The payment was declined because the pin code was attempted too many times.',

  // Credit Card errors
  charge_declined: 'The payment was declined.',
  charge_declined_insufficient_funds: 'The payment was declined due to insufficient funds.',
  insufficient_funds: 'The payment was declined due to insufficient funds.',
  charge_declined_lost_card: 'The payment was declined. Please contact your bank.',
  lost_card: 'The payment was declined. Please contact your bank.',
  charge_declined_stolen_card: 'The payment was declined. Please contact your bank.',
  stolen_card: 'The payment was declined. Please contact your bank.',
  restricted_card: 'The card cannot be used to make this payment. Please contact your bank.',
  pickup_card: 'The card cannot be used to make this payment. Please contact your bank.',
  not_permitted: "The payment isn't permitted. Please contact your bank.",
  new_account_information_available:
    'The card, or account the card is connected to, is invalid. Please contact your bank.',
  fraudulent: 'The payment was declined due to suspected fraud. Please contact your bank.',
  duplicate_transaction: 'The payment was declined because a duplicate transaction was detected.',
  do_not_try_again: 'The payment was declined. Please contact your bank.',
  do_not_honor: 'The payment was declined. Please contact your bank.',
  card_not_supported: 'The card does not support this type of purchase. Please contact your bank.',
  authentication_required: 'The payment was declined because additional authentication is required.',
  charge_declined_expired_card: 'The payment was declined because the card is expired',
  expired_card: 'This card has expired. Please try using another card for payment.',
  charge_declined_processing_error: 'The payment was declined due to a processing error',
  refund_fail: 'The refund of the captured charge has failed. Please try again.',
  card_declined: 'The payment was declined. Please contact your bank.',
  processing_error: 'An error occurred while processing your card. Try again in a little bit.',
  invalid_expiry_month: 'Your expiration date is invalid. Please enter the correct expiration date.',
  invalid_expiry_year: 'Your expiration date is invalid. Please enter the correct expiration date.',
  card_error:
    'Something went wrong while processing payment with this card. Please try using another card for payment.',
  card_velocity_exceeded: 'Your card was declined for making repeated attempts too frequently.',
  default:
    'An unknown error occurred. Otto staff has been alerted and is looking to resolve the issue as soon as possible.',

  // Generic errors
  email_invalid: 'The email address you entered is invalid. Please correct the email address and try again.',

  // Invalid input errors
  incomplete_number: 'Your card number is incomplete.',
  incomplete_expiry: "Your card's expiration date is incomplete.",
  incomplete_cvc: "Your card's security code is incomplete.",
  incomplete_zip: 'Your postal code is incomplete.',

  // Incorrect input errors
  incorrect_zip: 'Your postal code is incorrect.',
  incorrect_pin:
    'The payment was declined because an incorrect pin code was entered. Please have the client try again.',
  incorrect_cvc: 'The security code for the card you entered is incorrect.',
  incorrect_number: 'Your card number is invalid. Please try entering a valid card number.',
};
